<!--
 * @Author: yubaolee <yubaolee@163.com> | ahfu~ <954478625@qq.com>
 * @Date: 2021-06-01 14:10:29
 * @LastEditTime: 2022-12-19 21:21:11
 * @Description: 顶部导航
 * @
 * @Copyright (c) 2022 by yubaolee | ahfu~ , All Rights Reserved. 
-->
<template>
  <div class="tags-view-container">
    <!-- <scroll-pane class='tags-view-wrapper' ref='scrollPane'> -->
    <div class="tagssty tags-view-wrapper" ref="tagsP">
      <div class="iconl" @click="toLeft"><i class="el-icon-caret-left"></i></div>
      <div @click="gopath(tag.path)" v-for="tag in Array.from(visitedViews)" :key="tag.path">
        <router-link ref='tag' class="tags-view-item" :class="isActive(tag) ? 'active' : ''" :to="{ path: tag.path }"
          @contextmenu.prevent.native="openMenu(tag, $event)">
          {{ tag.title }}
          <span class='el-icon-close' @click.prevent.stop='closeSelectedTag(tag)'></span>
        </router-link>
      </div>
      <div class="iconr" @click="toRight"><i class="el-icon-caret-right"></i></div>
    </div>
    <!-- </scroll-pane> -->
    <ul class='contextmenu' v-show="visible" :style="{ left: left + 'px', top: top + 'px' }">
      <li @click="closeSelectedTag(selectedTag)">关闭</li>
      <!-- <li @click="refresh">刷新</li> -->
      <!-- <li @click="closeOthersTags">关闭其他</li> -->
      <li @click="closeAllTags">全部关闭</li>
    </ul>
  </div>
</template>

<script>
  import ScrollPane from '@/components/ScrollPane'
  import { mapGetters, mapMutations } from 'vuex'
  // Sortable 异步加载 (~111KB)
  export default {
    components: { ScrollPane },
    inject: ['reload','clearKeepAlive'],
    props: ['sendChildDate','close'],
    data() {
      return {
        visible: false,
        top: 0,
        left: 0,
        selectedTag: {},
        editableTabsValue: '2',
        editableTabs: [{
          title: 'Tab 1',
          name: '1',
          content: 'Tab 1 content'
        }, {
          title: 'Tab 2',
          name: '2',
          content: 'Tab 2 content'
        }],
        tabIndex: 2

      }
    },
    computed: {
      ...mapGetters(['iframeViews', 'visitedViews']),
    },
    watch: {
      $route() {
        // console.log('route')
        this.addViewTags()
        this.moveToCurrentTag()
      },
      visible(value) {
        if (value) {
          document.body.addEventListener('click', this.closeMenu)
        } else {
          document.body.removeEventListener('click', this.closeMenu)
        }
      }
    },
    mounted() {
      this.addViewTags()
      this.rowDrop()

    },
    methods: {
      ...mapMutations(['SET_ROUTERSdd']),
      //拖拽方法
      rowDrop() {
        const el = document.querySelector(".tagssty"); //找到想要拖拽的那一列

        const _this = this;
        import(/* webpackChunkName: "chunk-sortable" */ "sortablejs").then(({ default: Sortable }) => {
        Sortable.create(el, {
          onEnd({ newIndex, oldIndex }) {
            //oldIIndex拖放前的位置， newIndex拖放后的位置  //tabOptionList为遍历的tab签
            const currRow = _this.editableTabs.splice(oldIndex, 1)[0]; //鼠标拖拽当前的el-tabs-pane
            _this.editableTabs.splice(newIndex, 0, currRow); //tableData 是存放所以el-tabs-pane的数组
          },
        });
        })
      },

      generateRoute() {
        if (this.$route.name) {
          return this.$route
        }
        return false
      },
      isActive(route) {
        return route.path === this.$route.path
      },
      addViewTags() {
        const route = this.generateRoute()
        if (!route) {
          return false
        }
        if (!route.meta.noCache) {
          route.meta.noCache = true
        }

        this.toRight()
        this.$store.dispatch('addVisitedViews', route)
      },
      moveToCurrentTag() {
        const tags = this.$refs.tag
        this.$nextTick(() => {
          for (const tag of tags) {
            if (tag.to.path === this.$route.path) {
              // this.$refs.scrollPane.moveToTarget(tag.$el)
              break
            }
          }
        })
      },
      closeSelectedTag(view) {
        const route = this.generateRoute()
        route.meta.keepAlive = false

        this.$store.dispatch('delVisitedViews', view).then(views => {
          if (this.isActive(view)) {
            const latestView = views.slice(-1)[0]
            if (latestView) {
              this.$router.push({ path: latestView.path })
            } else {
              this.$router.push('/')
            }
          }
        })
        // console.log(this.$route.fullPath);
        this.close(this.$route.fullPath)
      },
      closeOthersTags() {
        this.$router.push(this.selectedTag)
        this.$store.dispatch('delOthersViews', this.selectedTag).then(() => {
          this.moveToCurrentTag()
        })
      },
      refresh() {
        this.reload()
      },
      handleClick(item) {
        // console.log(item);
      },
      closeAllTags() {
        this.$store.dispatch('delAllViews')
        this.$router.push('/')
        this.refresh()
      },
      gopath(path) {
        this.sendChildDate(path)
      },
      openMenu(tag, e) {
        this.visible = true
        this.selectedTag = tag
        const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
        this.left = e.clientX - offsetLeft + 15 // 15: margin right
        this.top = e.clientY-40
      },
      closeMenu() {
        this.visible = false
      },
      toRight() {
        // 往右滚动
        let distance = this.$refs.tagsP.scrollLeft;
        let scrollNum = distance + 200;
        let step = (distance - scrollNum) / 50;
        if (step < 0) step = -step;
        this.moveSlow(distance, scrollNum, step, true);
      },
      toLeft() {
        // 左滚动
        let distance = this.$refs.tagsP.scrollLeft;
        let scrollNum = distance - 200;
        if (scrollNum < 0) {
          scrollNum = 0;
        }
        let step = (distance - scrollNum) / 50;
        if (step < 0) step = -step;
        this.moveSlow(distance, scrollNum, step, false);
      },
      moveSlow(distance, total, step, LOR) {
        // 正向滚动 和 反向滚动
        if (LOR) {
          // 每隔1毫秒移动一小段距离，直到移动至目标至为止，反之亦然
          if (distance < total) {
            distance += step;
            this.$refs.tagsP.scrollLeft = distance;
            setTimeout(() => {
              this.moveSlow(distance, total, step, true);
            }, 1);
          } else {
            this.$refs.tagsP.scrollLeft = total;
          }
        } else if (!LOR) {
          if (distance > total) {
            distance -= step;
            this.$refs.tagsP.scrollLeft = distance;
            setTimeout(() => {
              this.moveSlow(distance, total, step, false);
            }, 1);
          } else {
            this.$refs.tagsP.scrollLeft = total;
          }
        }
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .custom-theme {
    .tags-view-container {
      .tags-view-wrapper {

        .tags-view-item {
          &.active {
            color: #000;
            background-color: rgba(0, 121, 255, 0.2);
            border: none;


            &::before {
              background: #000;
            }
          }
        }
      }
    }

  }

  .tags-view-container {
    margin-top: 45px;

    .tags-view-wrapper {
      background: #fff;
      height: 34px;
      border-bottom: 1px solid #d8dce5;
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);

      .tags-view-item {
        display: inline-block;
        position: relative;
        height: 26px;
        line-height: 26px;
        border: 1px solid #d8dce5;
        color: #495060;
        background: #fff;
        padding: 0 8px;
        font-size: 12px;
        margin-left: 5px;
        margin-top: 4px;

        &.active {
          color: #fff;
          background-color: #409eff;
          border-color: #409eff;

          &::before {
            content: '';
            background: #fff;
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            position: relative;
            margin-right: 2px;
          }
        }
      }
    }

    .contextmenu {
      margin: 0;
      background: #fff;
      z-index: 10000;
      position: absolute;
      list-style-type: none;
      padding: 5px 0;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #333;
      box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);

      li {
        margin: 0;
        padding: 7px 16px;
        cursor: pointer;

        &:hover {
          background: #eee;
        }
      }
    }
  }
</style>

<style rel="stylesheet/scss" lang="scss">
  .tags-view-wrapper {
    .tags-view-item {
      .el-icon-close {
        width: 16px;
        height: 16px;
        vertical-align: 2px;
        border-radius: 50%;
        text-align: center;
        transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
        transform-origin: 100% 50%;

        &:before {
          transform: scale(0.6);
          display: inline-block;
          vertical-align: -3px;
        }

        &:hover {
          background-color: #b4bccc;
          color: #fff;
        }
      }
    }
  }

  .tagssty {
    max-width: calc(100vw);
    display: flex;
    position: relative;
    overflow: hidden;
    // overflow-x: auto;
    white-space: nowrap;
    margin: 0 20px;

    &::-webkit-scrollbar {
      display: none !important;
    }

    .iconl {
      font-size: 20px;
      margin-top: 2px;
      position: fixed;
      // left: 100px;
      z-index: 999;
      margin-left: -20px;
      background-color: #fff;
      // left: 34px;
      color: var(--primary-color) !important;
    }

    .iconr {
      font-size: 20px;
      margin-top: 2px;
      position: fixed;
      right: 0;
      z-index: 999;
      background-color: #fff;
      color: var(--primary-color) !important;
    }
  }

  .tagssty::-webkit-scrollbar {
    display: none;
  }

  // ::-webkit-scrollbar{ display:none; }
</style>